// removed by extract-text-webpack-plugin
module.exports = {"modalComponent":"Gf5e92a"};